import React, { createContext, useContext, useLayoutEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { PRESETS, Theme, themeOf } from './palettes';
import { setBrandColors } from '../components/WhalesLabPage/whales';

// every CSS variable any palette sets, so switching palettes (or back to 'current') clears the previous one
const ALL_VARS = Object.keys(themeOf(PRESETS[0].id).vars);
const KEY = 'site-palette';
// under 'current', the WHALES Lab pages and the Work with me page take the Cover light palette (the rest of the site keeps its own colours)
const LAB_PATHS = ['/whalesLab', '/labMemberPage', '/recruitingPage'];
const LAB_CURRENT = 'paper';

// theme: what the page shows; chosen: the palette picked in the debug bar (they differ on the lab pages under 'current')
const PaletteCtx = createContext<{ theme: Theme, chosen: string, setPalette: (id: string) => void }>({ theme: themeOf('current'), chosen: 'current', setPalette: () => { } });
export const usePalette = () => useContext(PaletteCtx);

export const PaletteProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [id, setId] = useState<string>(() => { try { return localStorage.getItem(KEY) || 'current'; } catch (e) { return 'current'; } });
  const { pathname } = useLocation();
  const shown = id === 'current' && LAB_PATHS.includes(pathname) ? LAB_CURRENT : id;
  const theme = useMemo(() => {
    const t = themeOf(shown);
    setBrandColors(t.brand); // the mark engine is recoloured before anything below draws a logo
    return t;
  }, [shown]);

  useLayoutEffect(() => {
    const r = document.documentElement.style;
    ALL_VARS.forEach(v => r.removeProperty(v));
    Object.entries(theme.vars).forEach(([k, v]) => r.setProperty(k, v));
    document.documentElement.dataset.palette = theme.id;
  }, [theme]);
  useLayoutEffect(() => { try { localStorage.setItem(KEY, id); } catch (e) { } }, [id]);

  return <PaletteCtx.Provider value={{ theme, chosen: id, setPalette: setId }}>{children}</PaletteCtx.Provider>;
};
